import { __makeTemplateObject } from "tslib";
import React from 'react';
import { opacity, palette2, styled, withDelay } from '../../../foundation';
import { RcCircularProgress } from '../../Progress/CircularProgress';
export var StyledLoadingPage = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 0px;\n  left: 0px;\n  opacity: ", ";\n  background: ", ";\n  z-index: 1000;\n"], ["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 0px;\n  left: 0px;\n  opacity: ",
    ";\n  background: ", ";\n  z-index: 1000;\n"])), function (_a) {
    var backgroundType = _a.backgroundType;
    return backgroundType ? opacity('40', true) : 1;
}, palette2('neutral', 'b01'));
export var RcDefaultLoadingWithDelay = withDelay(function (_a) {
    var backgroundType = _a.backgroundType, size = _a.size, disableShrink = _a.disableShrink;
    return (React.createElement(StyledLoadingPage, { "data-test-automation-id": "loading-page", backgroundType: backgroundType },
        React.createElement(RcCircularProgress, { size: size, disableShrink: disableShrink })));
});
var templateObject_1;
